import { render } from "./ProfileDatatable.vue?vue&type=template&id=794f4862"
import script from "./ProfileDatatable.vue?vue&type=script&lang=js"
export * from "./ProfileDatatable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__